import { render } from "./DropdownItem.vue?vue&type=template&id=2772ec46&scoped=true&ts=true"
import script from "./DropdownItem.vue?vue&type=script&lang=ts"
export * from "./DropdownItem.vue?vue&type=script&lang=ts"

import "./DropdownItem.vue?vue&type=style&index=0&id=2772ec46&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2772ec46"]])

export default __exports__